import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {TextMessage} from '../model/email/TextMessage';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {Message} from '../model/microsite/message';
import {EmailImage} from '../model/email/emailImage';

@JsonConverter
export class EmailImageArrayConverter implements JsonCustomConvert<Array<EmailImage>> {

    deserialize(json: any): Array<EmailImage> {

        // const msgArr = new Array<TextMessage>();
        // return Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(json,EmailImage);
        /*const temp:TSMap<string,string>= new TSMap();
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;*/

        const imageMsgArr:Array<EmailImage> =  [];
        // const temp:TSMap<string,EmailBanner>= new TSMap();

        for (const item of json) {
            imageMsgArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,EmailImage));
        }

        return imageMsgArr;
    }

    serialize(data: Array<EmailImage>): any {
        return JSON.stringify(data);
    }
}
